var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconFlag(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 9.525,
    height: 11.43,
    viewBox: "0 0 9.525 11.43",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Icon_ionic-md-flag",
    "data-name": "Icon ionic-md-flag",
    d: "M15.68,5.072A11.717,11.717,0,0,1,14.2,5.2a11.89,11.89,0,0,1-2.426-.363,12.382,12.382,0,0,0-2.5-.333,4.748,4.748,0,0,0-2.4.4l-.125.086V15.93H8.179v-5.3a9.03,9.03,0,0,1,1.1-.06,12.047,12.047,0,0,1,2.375.461,12.767,12.767,0,0,0,2.587.342,11.813,11.813,0,0,0,1.441-.119c.223-.027.417-.051.6-.08V4.982C16.126,5.012,15.9,5.045,15.68,5.072Z",
    transform: "translate(-6.75 -4.5)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconFlag);
export default __webpack_public_path__ + "static/media/icon-flag.14c05d800cd3ce321996010c8c562c98.svg";
export { ForwardRef as ReactComponent };